import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brand-by-category',
  templateUrl: './brand-by-category.component.html',
  styleUrls: ['./brand-by-category.component.css']
})
export class BrandByCategoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/brand-by-category/brand-by-category.component.ts